module.exports = __webpack_public_path__ + "static/media/naszemiasto.8059f2c1.png";